/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import CampaignModel from 'cio/models/campaign';
import DS from 'ember-data';
import { inject as service } from '@ember/service';

interface TriggerFrequencyDescriptionArgs {
  campaign: CampaignModel;
}

export default class TriggerFrequencyDescription extends Component<TriggerFrequencyDescriptionArgs> {
  @service store!: DS.Store;

  get objectType() {
    let objectTypeId =
      this.args.campaign.objectTypeId ??
      this.args.campaign.objectCampaign?.objectTypeId ??
      this.args.campaign.relationshipCampaign?.objectTypeId;

    if (objectTypeId == null) {
      return null;
    }
    return this.store.peekRecord('object-type', objectTypeId);
  }
}
